module.exports = __webpack_public_path__ + "b2613cab59df5e4ea0f26e003880ce79.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/beak/mustache-thick-s.png
// module id = 1823
// module chunks = 0